<template>
  <div>
    <div class="pop-step-msg">
      <img src="../../../assets/images/lottery/timelin1.png">
    </div>
    <div class="step-row">
      <div class="step-row-in" :style="{width: scanTimes * 10 + '%'}"></div>
    </div>
    <div class="step-number">
      <div v-for="(item, index) in 10" :key="index" :class="{ 'text-red': item===scanTimes  }" >{{ item }}次</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LotteryPopupStep',
  computed: {
    scanTimes () {
      return this.$store.state.lottery.scanTimes
    }
  }
}
</script>

<style lang="less" scoped>
.pop-step-msg {
  height: 22px;
  text-align: right;
  margin: 10px 0 4px 0;
  img {
    width: auto;
    height: 100%;
  }
}
.step-row {
  height: 16px;
  width: 100%;
  border-radius: 10px;
  background-color: #fcefef;
  border: 3px solid #000000;
  box-sizing: border-box;
  .step-row-in {
    height: 10px;
    background-image: linear-gradient(to right, #2f555f , #d7d8d8);
    border-radius: 5px;
    display: flex;
  }
}
.step-number {
    display: flex;
    justify-content: space-between;
    // padding: 0 10px;/
    div {
      font-size: 10px;
      // width: 10%;
      text-align: center;
      margin-top: 5px;
      color: #666;
    }
    .text-red {
      font-weight: bold;
      color: #ed4836
    }
  }
</style>
